export const environment = {
  production: false,
  apiRoot: ""
};
